/* eslint-disable camelcase */
export enum Resource {
  Forms = 'forms',
  Groups = 'groups',
  Layers = 'layers',
  Projects = 'projects',
  Roles = 'roles'
}

export interface Membership {
  id: string;
  created_at: string;
  updated_at: string;
  gravatar_email?: string;
  gravatar_image_url?: string;
  user_id: string;
  user: string;
  first_name: string;
  last_name: string;
  email: string;
  role_id: string;
  role_name: string;
  device_info: {
    last_sync: string;
    platform: string;
    platform_version: string;
    model: string;
    app_version: string;
    ip_address: string;
  };
  last_sync: string;
  image_small?: string;
  image_large?: string;
  is_managed: boolean;
  is_editable: boolean;
  existing_user?: boolean;
}

export interface MembershipAPIResult {
  memberships: Membership[];
  current_page: number;
  per_page: number;
  total_count: number;
  total_pages: number;
}

export default class Member {}
